import { render, staticRenderFns } from "./MerchantProductDetails.vue?vue&type=template&id=65d7a364&scoped=true&"
import script from "./MerchantProductDetails.vue?vue&type=script&lang=js&"
export * from "./MerchantProductDetails.vue?vue&type=script&lang=js&"
import style0 from "./MerchantProductDetails.vue?vue&type=style&index=0&id=65d7a364&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d7a364",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/development/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65d7a364')) {
      api.createRecord('65d7a364', component.options)
    } else {
      api.reload('65d7a364', component.options)
    }
    module.hot.accept("./MerchantProductDetails.vue?vue&type=template&id=65d7a364&scoped=true&", function () {
      api.rerender('65d7a364', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shopApp/routes/shop/merchant/MerchantProductDetails.vue"
export default component.exports